"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createMuiStrictModeTheme;
var _deepmerge = _interopRequireDefault(require("@mui/utils/deepmerge"));
var _createTheme = _interopRequireDefault(require("./createTheme"));
function createMuiStrictModeTheme(options) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return (0, _createTheme.default)((0, _deepmerge.default)({
        unstable_strictMode: true
    }, options), ...args);
}
